import React from 'react';
import { connect } from 'react-redux';
import { Box } from '@mui/material';

import { State as RootState } from '@occc-app/rootRedux';

import { actions, State } from './redux';
import { LocationInStateConfiguration, RequiresActivationConfiguration } from './components';

type Actions = typeof actions;

type ConstraintBaseProps = {
  constraintConfigurationUpdate: Actions['constraintConfigurationUpdate'];
  fieldDisabled: (field: any) => boolean;
};

type Props = State & Actions & { editMode: boolean; readOnly: boolean };
class ShowConstraints extends React.Component<Props, {}> {
  renderDivider() {
    const {
      locationInState: { states },
      readOnly,
      requiresActivation: { active: requiresActivationActive },
    } = this.props;

    const shouldRenderDivider =
      !readOnly || (readOnly && states.length > 0 && requiresActivationActive);

    if (!shouldRenderDivider) {
      return;
    }

    return <Box borderTop='1px solid' borderColor='grayLight' my={3} />;
  }

  renderLocationInState(constraintBaseProps: ConstraintBaseProps) {
    const {
      editMode,
      locationInState,
      locationInState: { active },
    } = this.props;

    if (!active) {
      return;
    }

    const locationProps = {
      ...constraintBaseProps,
      ...locationInState,
      editMode,
    };
    return <LocationInStateConfiguration {...locationProps} />;
  }

  renderRequiresActivation(constraintBaseProps: ConstraintBaseProps) {
    const {
      readOnly,
      requiresActivation,
      requiresActivation: { active },
    } = this.props;

    if (!active) {
      return;
    }

    const reqActProps = {
      ...constraintBaseProps,
      ...requiresActivation,
      readOnly,
    };
    return <RequiresActivationConfiguration {...reqActProps} />;
  }

  render() {
    const { constraintConfigurationUpdate, readOnly } = this.props;

    const constraintBaseProps: ConstraintBaseProps = {
      constraintConfigurationUpdate,
      fieldDisabled: () => readOnly,
    };

    return (
      <Box>
        {this.renderLocationInState(constraintBaseProps)}
        {this.renderDivider()}
        {this.renderRequiresActivation(constraintBaseProps)}
      </Box>
    );
  }
}

type MapStateToProps = (state: RootState) => State;
const mapStateToProps: MapStateToProps = ({ offer: { constraints } }) => constraints;

export default connect(mapStateToProps, actions)(ShowConstraints);
